import MaterialTable from "material-table";
import { useEffect } from "react";
import {
    Box,
    Button,
    Select,
    Typography,
    MenuItem,
    Grid,
    CircularProgress,
    IconButton,
    FormControl,
    TextField,
    FormLabel,
    InputLabel,
    Menu,
    Tooltip,
    List,
    ListItem,
    ListItemText,
    Accordion,
    AccordionSummary,
    AccordionDetails
} from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import { useState } from "react";
import { getUserData, getUserId, revertDateFormat } from "../../../Base/helper/baseFunctions";
import Popup from "../../../Base/views/Popup";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import axiosInstance from "../../../../../axiosInstance";
import { HRMS_LMS_API_URL } from "../../../../Constants/baseConstant";
import { AddBioMetricDataStagetoMainHelper, AddMonthlyDaysStagetoMainHelper, AddTimeDataStagetoMainHelper, DeleteBioMetricDataStageHelper, DeleteTimeDataStageHelper, GetAttendanceDataStageHelper, GetBioMetricDataStageHelper, GetBiometricPrefillHelper, GetMonthlyWorkingDataStageHelper, GetTimeDataStageHelper, UpdateBioMetricDataStageHelper, UpdateTimeDataStageHelper } from "../../../Finance/helper/BulkUpload/BulkUploadHelper";
import ConfirmationDialog from "../../../Base/views/ConfirmationDialog";
import CommonDatePicker from "../../../Base/views/CommonDatePicker";
import Papa from "papaparse";
import Warning from "../../image/report.png";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useDispatch, useSelector } from "react-redux";
import { GetAttendanceCodeAction } from "../../../../../store/Leave/AttendanceBulkNotationCode/Action";
import Base from "../../../Base/views/Base";
import BackdropMeepl from "../../../Ancillary/AnimationComponents/BackdropMeepl";

const BioMetricUpload = () => {
    let userData = getUserData();
    const dispatch = useDispatch();
    const date = new Date();
    const [inputData, setInputData] = useState({ type: "Check In - Check Out" });
    const [input, setInput] = useState({ month_year: `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}` });
    const [showConfirmPopup, setShowConfirmPopup] = useState(false);
    const [Import, setImport] = useState(false);
    const [show, setShow] = useState(false);
    const [hours, setHours] = useState(false);
    const [attendanceBulk, setAttendanceBulk] = useState(false);
    const [monthlyDaysBulk, setMonthlyDaysBulk] = useState(false);
    const [mode, setMode] = useState("Check In - Check Out");
    const [clickedSource, setClickedSource] = useState("");
    const [prefillOpen, setPrefillOpen] = useState(false);
    const [type, setType] = useState("");
    const [loader, setLoader] = useState(false);
    const [loader2, setLoader2] = useState(false);
    const [loader3, setLoader3] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [editedRecord, setEditedRecord] = useState(null);
    const [id, setId] = useState();
    const [openPopup, setOpenPopup] = useState(false);
    const [updatingLoader, setUpdatingLoader] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [currentData, setCurrentData] = useState({});
    const [empdata, setEmpData] = useState([]);
    const [stageData, setStageData] = useState([]);
    const [hoursdata, setHoursData] = useState([]);
    const [file, setFile] = useState(null);
    const [failedMessage, setFailedMessage] = useState("");
    const initialColMapping = [
        { excel: "", db: "previous_employee_id", label: "Prev.Emp ID", required: true },
        { excel: "", db: "in_date", label: "In Date", required: true },
        { excel: "", db: "out_date", label: "Out Date", required: true },
        { excel: "", db: "in_time", label: "In Time", required: true },
        { excel: "", db: "out_time", label: "Out Time", required: true },
    ];
    const [excelDbColMapping, setExcelDbColMapping] = useState(initialColMapping);
    const [rowHeaders, setRowHeaders] = useState([]);
    const [uploadProgress, setUploadProgress] = useState(0);
    const { minDojYear } = useSelector(state => state?.AncillaryReducer?.WorkSpaceDojReducer);
    const convertDateToISO = (dateStr) => {
         if (!dateStr) return "";
        const parts = dateStr.split("-");
        const day = parts[0].padStart(2, "0");
        const month = parts[1].padStart(2, "0");
        const year = parts[2];
        return `${year}-${month}-${day}`;
    };
    const [getLoading, setGetLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const { atdCodeLoading, attendanceCodeData } = useSelector(
        (state) => state?.LeaveReducer.AttendanceReducer
      );
    useEffect(() => {
        const fetchData = async () => {
            try {
                setGetLoading(true);
                const [bioMetricRes, timeRes, attendanceRes, monthlyWorking] = await Promise.all([
                    GetBioMetricDataStageHelper(),
                    GetTimeDataStageHelper(),
                    GetAttendanceDataStageHelper(),
                    GetMonthlyWorkingDataStageHelper()
                ]);

                setStageData(bioMetricRes?.data?.data || timeRes?.data?.data || attendanceRes?.data?.data || monthlyWorking?.data?.data || [])
                const bioMetricData = bioMetricRes?.data?.data?.[0];
                const timeData = timeRes?.data?.data?.[0];
                const attendanceData = attendanceRes?.data?.data?.[0];
                const monthlyWorkingData = monthlyWorking?.data?.data?.[0]
                 if (bioMetricData?.stage_biometric_pk) {
                    setEmpData(bioMetricData?.biometric_details);
                    setHours(false);
                    setId(bioMetricData?.stage_biometric_pk);
                    setMode(bioMetricData.mode);
                } else if (timeData?.time_detail_stage_pk) {
                    setEmpData(timeData?.time_details);
                    setHours(true);
                    setId(timeData?.time_detail_stage_pk);
                    setMode(timeData?.mode);
                } else if (attendanceData?.attendance_detail_stage_pk) {
                    setEmpData(attendanceData?.attendance_details);
                    setHours(true);
                    setAttendanceBulk(true);
                    setId(attendanceData?.attendance_detail_stage_pk);
                    setMode(attendanceData.mode);
                } else if (monthlyWorkingData?.monthly_working_detail_stage_pk) {
                    setEmpData(monthlyWorkingData?.monthly_working_details);
                    setHours(false);
                    setAttendanceBulk(false);
                    setId(monthlyWorkingData?.monthly_working_detail_stage_pk);
                    setMode(monthlyWorkingData.mode);
                    setMonthlyDaysBulk(true);
                }
            } catch (error) {
                console.error("Failed to fetch biometric or time data", error);
            } finally {
                setGetLoading(false);
            }
        };

        fetchData();
        dispatch(GetAttendanceCodeAction());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    
    // Structure data for chips
    useEffect(() => {
    if (attendanceCodeData?.length > 0) {
        const grouped = new Map();

        attendanceCodeData.forEach((item) => {
        const key = item?.meepl_label;

        if (!grouped.has(key)) {
            grouped.set(key, {
            attendance_bulk_notation_mapping_pk:
                item.attendance_bulk_notation_mapping_pk,
            meepl_label: item.meepl_label,
            user_code: [item.company_label],
            });
        } else {
            const existing = grouped.get(key);
            if (!existing.user_code.includes(item.company_label)) {
            existing.user_code.push(item.company_label);
            }
        }
        });
        const structured = Array.from(grouped.values());
        setRows(structured);
    }
    }, [attendanceCodeData]);
    const handleImport = () => {
        if (stageData?.length > 0 || empdata?.length > 0) {
            setShowConfirmPopup(true); 
        } else {
            setMode("Check In - Check Out");
            setImport(true);
            setFailedMessage("");
        }
    };
    const fileSelected = (e) => {
        const selectedFile = e.target.files[0];
        if (!selectedFile) return;
        if (!selectedFile.name.endsWith(".csv")) {
            setShow(true);
            return;
        }
        // processFile(selectedFile, e);
        processCSVFile(selectedFile, e);
    };
    
    const processCSVFile = (selectedFile, event) => {
        setFile(selectedFile);
        setUploadProgress(0);
        toast.info("Reading CSV File. Please wait...");
        Papa.parse(selectedFile, {
            header: true,
            skipEmptyLines: true,
             beforeFirstChunk: (chunk) => {
                const filteredChunk = chunk
                    ?.split("\n")
                    ?.filter(line => !line?.trim()?.startsWith("#"))
                    ?.join("\n");
                return filteredChunk;
            },
            complete: (result) => {
                if (hours) {
                    const processedData = processDailyHoursCSV(result.data);
                    setHoursData(processedData);
                }
                if(monthlyDaysBulk) {
                    const processedData = processMonthlyDaysCSV(result.data);
                    setHoursData(processedData);
                }
                const headers = Object.keys(result.data[0]);
                setRowHeaders(headers);
                toast.dismiss();
                toast.success("File imported successfully!");
            },
            error: (error) => {
                toast.error(`Error reading CSV file: ${error.message}`);
            }
        });

        if (event) event.target.value = "";
    };
    const processDailyHoursCSV = (data) => {
        if (data?.length === 0) return [];
        const headers = Object.keys(data[0]);
        const normalizedHeaders = headers?.map(h => h?.trim().toLowerCase());
        const empIdKey = headers?.find((key, idx) =>
            normalizedHeaders[idx].includes("emp id")
        );
         const overtimeKey = headers?.find((key, idx) => {
            const lower = normalizedHeaders[idx];
            return lower.includes("overtime") || lower === "ot hours for complete pay period";
        });
        const dateHeaderRegex = /^\d{2}-\d{2}-\d{4}$/;
        const dateColumns = headers?.filter(h => dateHeaderRegex.test(h?.trim()));
         return data?.map(row => {
            const timeJson = {};
            dateColumns.forEach(dateCol => {
                const value = row[dateCol];
                const isoDate = convertDateToISO(dateCol.trim());
                    timeJson[isoDate] = value?.trim() || "0.0";
            });
            let overtimeHour = overtimeKey ? row[overtimeKey] : null;
            if (!overtimeHour?.trim()) {
                overtimeHour = "0.0";
            }
            const overtime_hours = (overtimeHour?.trim())
                ? String(overtimeHour)?.trim()
                : null;
            let result = {
                previous_employee_id: empIdKey ? row[empIdKey] : null,
                time_json: timeJson,
            };
            if (attendanceBulk && overtime_hours) {
                result.overtime_hours = overtime_hours;
            }
            return result;
        });
    };
    const processMonthlyDaysCSV = (data) => {
        if (data?.length === 0) return [];
        const headers = Object.keys(data[0]);
        const normalizedHeaders = headers?.map(h => h?.trim().toLowerCase());
        const empIdKey = headers?.find((key, idx) =>
            normalizedHeaders[idx].includes("emp id")
        );
         const overtimeKey = headers?.find((key, idx) => {
            const lower = normalizedHeaders[idx];
            return lower.includes("overtime") || lower === "ot hours for complete pay period";
        });
         const workingDayKey = headers?.find((key, idx) => {
            const lower = normalizedHeaders[idx];
            return lower.includes("working") || lower === "working days";
        });
        
         return data?.map(row => {
            let overtimeHour = overtimeKey ? row[overtimeKey] : null;
            if (!overtimeHour?.trim()) {
                overtimeHour = "0.0";
            }
            const overtime_hours = (overtimeHour?.trim())
                ? String(overtimeHour)?.trim()
                : null;
            const rawWorkingDays = workingDayKey ? row[workingDayKey] : null;
            const validatedWorkingDays = validateWorkingDays(rawWorkingDays);
            let result = {
                previous_employee_id: empIdKey ? row[empIdKey] : null,
                working_days: validatedWorkingDays || "0",
                overtime_hours : overtime_hours
            };
            return result;
        });
    };
    function setColMapping(value, dbCol) {
        setExcelDbColMapping((prev) => {
            prev?.forEach((col) => {
                if (col["db"] === dbCol) col.excel = value;
            });
            return [...prev];
        });
    }
    function clearColMapping(dbCol) {
        setExcelDbColMapping((prev) => {
            prev?.forEach((col) => {
                if (col["db"] === dbCol) col.excel = "";
            });
            return [...prev];
        });
    }
    const validate = () => {
        const temp = {};
        if (!file) temp.file = "File is required";
        const unmappedRequiredFields = excelDbColMapping.filter(
            (col) => col.required && !col.excel
        );
        if (unmappedRequiredFields.length > 0) {
            toast.error("Please map all required fields.")
            temp.columnMapping = "Please map all required fields.";
        }
        if ((hours || monthlyDaysBulk) && (!input?.month_year)) {
            toast.error("Please choose Year and Month.");
        }
        return Object.keys(temp).length === 0; // Return true if no errors
    };
    async function addEmployeeStage(e) {
        if (!validate()) return;
        e.preventDefault();
        setFailedMessage("");
        try {
            const formData = new FormData();
            formData.append("file", file);
            formData.append("user_id", getUserId());
            formData.append("mode", inputData?.type);
            formData.append("domain_name", userData?.domain);
            if (hours || monthlyDaysBulk) {
                const [f_year, month] = input.month_year.split("-");
                const f_month = parseInt(month, 10).toString();
                formData.append("month", f_month);
                formData.append("year", f_year);
                formData.append("column_mapping", JSON.stringify(hoursdata));
            }
            else {
                formData.append("column_mapping", JSON.stringify(excelDbColMapping));
            }
            toast.info("Uploading file");
            try {
                setUploadProgress(0);
                await axiosInstance
                    .post("/lms/uploadBioMetricFile", formData, {
                        baseURL: HRMS_LMS_API_URL,
                        headers: {
                            Accept: "multipart/form-data",
                            "Content-Type": "multipart/form-data",
                        },
                        onUploadProgress: (progress) => {
                            const percentCompleted = Math.round(
                                (progress.loaded * 90) / progress.total
                            );
                            setUploadProgress(percentCompleted);
                            if (percentCompleted > 89) {
                                toast.dismiss();
                                toast.info("Uploading...");
                            }
                        },
                    })
                    .then((response) => { 
                        const result = response?.data?.statuscode;
                        setEmpData(response?.data?.data?.[0]?.biometric_details || response?.data?.data?.[0]?.time_details || response?.data?.data?.[0]?.attendance_details || response?.data?.data?.[0]?.monthly_working_details)
                        setId(response?.data?.data?.[0]?.stage_biometric_pk || response?.data?.data?.[0]?.time_detail_stage_pk || response?.data?.data?.[0]?.attendance_detail_stage_pk || response?.data?.data?.[0]?.monthly_working_detail_stage_pk)
                        setStageData(response?.data?.data);
                        if (result) {
                            toast.dismiss();
                            toast.success("File uploaded successfully!");
                        }
                    });

                setUploadProgress(100);
                setFile(null);
                setImport(false);
                setFile(null);
                setRowHeaders([]);
                setInputData({ type: "Check In - Check Out" });

            } catch (error) {
                setUploadProgress(0);
                toast.warning(error.response?.data?.message || error.message);
            }
        } catch (error) {
            console.error("Unexpected error", error);
        }

    }
    async function handleSubmit(e) {
        setLoader3(true);
        if (hours) {
            AddTimeDataStagetoMainHelper({mode}).then((res) => {
                if (res.data.statuscode === 200) {
                    const resMessage = res?.data?.data?.[0]?.["fn_upsert_imported_time_data"] || res?.data?.data?.[0]?.["fn_upsert_imported_attendance_data"]
                    toast.dismiss();
                    toast.success("File processed successfully!");
                    if (resMessage?.split(" ")[0] > 0) {
                        setFailedMessage(`Time bulk upload failed for ${resMessage?.split(" ")[0]} record(s): Previous Employee ID is missing.`)
                    }
                    setEmpData([]);
                    setStageData([]);
                    setMode("Check In - Check Out");
                    setHours(false);
                }
                else {
                    toast.error("The bulk upload failed. Please try again");
                }
                setLoader3(false);
            });
        } else if (monthlyDaysBulk) {
            AddMonthlyDaysStagetoMainHelper().then((res) => {
                if (res.data.statuscode === 200) {
                    const resMessage = res?.data?.data?.[0]?.["fn_upsert_imported_monthly_working_days_data"] 
                    toast.dismiss();
                    toast.success("File processed successfully!");
                    if (resMessage?.split(" ")[0] > 0) {
                        if(monthlyDaysBulk) {
                            setFailedMessage(`Time bulk upload failed for ${resMessage?.split(" ")[0]} record(s): Previous Employee ID/Working days is missing.`)
                        } else {
                            setFailedMessage(`Time bulk upload failed for ${resMessage?.split(" ")[0]} record(s): Previous Employee ID is missing.`);
                        }
                    }
                    setEmpData([]);
                    setStageData([]);
                    setMode("Check In - Check Out");
                    setMonthlyDaysBulk(false);
                }
                else {
                    toast.error("The bulk upload failed. Please try again");
                }
                setLoader3(false);
            });
        }
        else {
            AddBioMetricDataStagetoMainHelper().then((res) => {
                if (res.data.statuscode === 200) {
                    const resMessage = res?.data?.data?.[0]?.["fn_upsert_imported_biometric_data"]
                    toast.dismiss();
                    toast.success("File processed successfully!");
                    if (resMessage?.split(" ")[0] > 0) {
                        setFailedMessage(`Time bulk upload failed for ${resMessage?.split(" ")[0]} record(s): Previous Employee ID is missing.`)
                    }
                    setEmpData([]);
                    setStageData([]);
                    setMode("Check In - Check Out");
                    setHours(false);
                }
                else {
                    toast.error("The bulk upload failed. Please try again");
                }
                setLoader3(false);
            });
        }
    }
    const handleCancel = () => {
        
        if (hours || monthlyDaysBulk) {
            setLoader2(true);
            DeleteTimeDataStageHelper({ time_detail_stage_id: stageData?.length > 0 ? null : id, mode: mode }).then((res) => {
                if (res.data.statuscode === 200) {
                    setStageData([]);
                    setEmpData([]); // Clear table data
                    setImport(true);
                    setMode("Check In - Check Out");
                    setHours(false);
                    setAttendanceBulk(false);
                    setFile(null);
                    setExcelDbColMapping(initialColMapping);
                    setFailedMessage("");
                    setRowHeaders([]);
                } else {
                    toast.error("Something went wrong")
                }
                setLoader2(false);
                setShowConfirmPopup(false);
            });
        }
        else {
            setLoader2(true);
            DeleteBioMetricDataStageHelper({ stage_biometric_id: stageData?.length > 0 ? null : id }).then((res) => {
                if (res.data.statuscode === 200) {
                    setStageData([]);
                    setEmpData([]); // Clear table data
                    setImport(true);
                    setMode("Check In - Check Out");
                    setFile(null); // Allow new file selection
                    setHours(false);
                    setAttendanceBulk(false);
                    setExcelDbColMapping(initialColMapping);
                    setFailedMessage("");
                    setRowHeaders([]);
                } else {
                    toast.error("Something went wrong")
                }
                setLoader2(false);
                setShowConfirmPopup(false);
            });
        }

    };
    const handleEdit = (rowData) => {
        setEditedRecord(rowData);
        setOpenPopup(true);
    };
    const handleConfirmDelete = (rowData) => {
        setOpenDialog(true);
        setCurrentData(rowData)
    };
    const handleDelete = () => {
        const updatedData = empdata?.filter(emp => emp?.previous_employee_id !== currentData?.previous_employee_id); // Use unique field
        setEmpData(updatedData); // Update state
        toast.dismiss();
        toast.success("Record deleted successfully!");
        setOpenDialog(false);
        if (hours || monthlyDaysBulk) {
            UpdateTimeDataStageHelper({time_detail_stage_id: id,time_details: JSON.stringify(updatedData),mode: mode}).then((res) => {});
        }
        else {
            UpdateBioMetricDataStageHelper({ stage_biometric_id: id, biometric_details: JSON.stringify(updatedData), mode: mode }).then((res) => {
            });
        }
    };
    const validateFields = () => {
        const tempErrors = {};

        // Always validate previous_employee_id
        if (!editedRecord?.previous_employee_id) {
            tempErrors.previous_employee_id = "Prev.Emp ID is required.";
        }

        // If hours is false, validate the date & time fields
        if (!hours && !monthlyDaysBulk) {
            if (!editedRecord?.in_date) tempErrors.in_date = "In Date is required.";
            if (!editedRecord?.out_date) tempErrors.out_date = "Out Date is required.";
            if (!editedRecord?.in_time) tempErrors.in_time = "In Time is required.";
            if (!editedRecord?.out_time) tempErrors.out_time = "Out Time is required.";
        }
        return Object.keys(tempErrors).length === 0; // Return true if no errors
    };
    const handleEditSubmit = (updatedRecord) => {
        if (!validateFields()) return;
        if (hours|| monthlyDaysBulk) {
            setUpdatingLoader(true);
            let cleanedRecord = updatedRecord;
            const { total_hours, ...filteredRecord } = updatedRecord;
            cleanedRecord = filteredRecord;
            const updatedData = empdata?.map(emp =>
                emp?.tableData?.id === cleanedRecord?.tableData?.id ? cleanedRecord : emp
            )
            UpdateTimeDataStageHelper({
                time_detail_stage_id: id,
                time_details: JSON.stringify(updatedData),
                mode: mode
            }).then((res) => {
                if (res?.data?.statuscode === 200) {
                    toast.dismiss();
                    toast.success("Record updated successfully!");
                    setEmpData(res?.data?.data?.[0]?.time_details || res?.data?.data?.[0]?.attendance_details || res?.data?.data?.[0]?.monthly_working_details)
                } else {
                    toast.dismiss();
                    toast.success("Something went wrong");
                }
                setOpenPopup(false);
                setUpdatingLoader(false);
            });
        } else {
            setUpdatingLoader(true);
            const updatedData = empdata?.map(emp =>
                emp?.tableData?.id === updatedRecord?.tableData?.id ? updatedRecord : emp
            )
            setEmpData(updatedData); // Update state
            UpdateBioMetricDataStageHelper({
                stage_biometric_id: id,
                biometric_details: JSON.stringify(updatedData),
                mode: mode
            }).then((res) => {
                if (res?.data?.statuscode === 200) {
                    toast.dismiss();
                    toast.success("Record updated successfully!");
                } else {
                    toast.dismiss();
                    toast.success("Something went wrong");
                }
                setOpenPopup(false);
                setUpdatingLoader(false);
            });
        }
    };
    const handleInputChange = async (event, value) => {
        if (event.target.value === "Daily Hours") {
            setHours(true);
            setExcelDbColMapping([]);
            setMode("Daily Hours");
        }
        else if (event.target.value === "Attendance Marking") {
            setHours(true);
            setAttendanceBulk(true);
            setMonthlyDaysBulk(false);
            setMode("Attendance Marking");
            setExcelDbColMapping([]);
        } else if(event.target.value === "Monthly Days") {
            setHours(false);
            setAttendanceBulk(false);
            setMonthlyDaysBulk(true);
            setMode("Monthly Days");
            setExcelDbColMapping([]);
        }
        else {
            setHours(false);
            setAttendanceBulk(false);
            setMonthlyDaysBulk(false);
            setMode("Check In - Check Out");
            setExcelDbColMapping(initialColMapping);
        }
        setInputData({ ...inputData, [event.target.name]: event.target.value });
        setFile(null);
    };
    const handleInput = (event, value) => {
        if (["month_year"].includes(event?.target?.name)) {
            setInput({ ...input, [event?.target?.name]: event?.target?.value });
        }
    }
    
    const getAttendanceSampleData = (type) => {
        const today = new Date();
        const year = today.getFullYear();
        const month = today.getMonth(); 
        const daysInMonth = new Date(year, month + 1, 0).getDate();

        // Generate date headers in 02-05-2025 format
        const dateHeaders = [];
        for (let day = 1; day <= daysInMonth; day++) {
            const dd = String(day).padStart(2, "0");
            const mm = String(month + 1).padStart(2, "0");
            dateHeaders.push(`${dd}-${mm}-${year}`);
        }
        const header = ["Prev.Emp ID", ...dateHeaders];
        let row1, row2;

        if (type === "attendance") {
            header.push("OT Hours For Complete Pay Period");
            row1 = ["EMP00123", ...Array(daysInMonth).fill("1.0"), "6.0"];
            row2 = ["EMP00124", ...Array(daysInMonth).fill("0.5"), "5.0"];
        } else {
            row1 = ["EMP00123", ...Array(daysInMonth).fill("9.0")];
            row2 = ["EMP00124", ...Array(daysInMonth).fill("8.0")];
        }

        return [header, row1, row2];
    };
    const handleOpenMenu = (event, source) => {
        setClickedSource(source);
        setAnchorEl(event.currentTarget);
    };
    const handleCloseMenu = () => {
        setAnchorEl(null);
    };
    const handleMenuItemClick = (type) => {
        setType(type)
        handleCloseMenu();
        if (clickedSource === "sample") {
            handleDownload(type);
        } else if (clickedSource === "prefill") {
            setPrefillOpen(true);
        }
    };
    const commonGuides = [
        "Prev.Emp ID: Reference ID / Employee ID from the legacy system / Org ID / Biometric ID as applicable."
    ];
    const guides = {
        "attendance": [...(rows || [])?.map((item) => {
                const code = (item?.user_code || []).join(" / ");
                return `${code} : ${item?.meepl_label}`
            }), 
            "- : No data (like DOJ mid-month/LOP)",
            "Dates : dd-mm-yyyy format (e.g. 01-01-2025)",
            "Please note: Notations that are not configured will be automatically skipped during processing."
        ],
        "in": [
            "In Time/Out Time : hh:mm:ss format (e.g. 08:00:00)",
            "In Date/Out Date : dd-mm-yyyy format (e.g. 01-01-2025)"
        ],
        "daily": [
            "Work Hour Code is WH9 : Enter 9",
            "Dates : dd-mm-yyyy format (e.g. 01-01-2025)"
        ],
        "monthlyDays" : [
            "Working Days cannot exceed the total days in the selected month."
        ]
    };
    const handleDownload = (type) => {
        let data, fileName, guideLines= [];
        if (type === "in") {
            const today = new Date();
            const dd = String(today.getDate()).padStart(2, "0");
            const mm = String(today.getMonth() + 1).padStart(2, "0");
            const yyyy = today.getFullYear();
            const formattedDate = `${dd}-${mm}-${yyyy}`;  // 01-05-2025 date format
            data = [
                ["Prev.Emp ID", "In Date", "Out Date", "In Time", "Out Time"],
                ["EMP00123", formattedDate, formattedDate, "08:00:00", "20:00:00"],
            ];
            fileName = "Check In - Check Out.csv";
            guideLines= guides["in"]
        } else if (type === "daily") {
            data = getAttendanceSampleData("daily");
            fileName = "Daily_Hours.csv";
            guideLines = guides["daily"];
        }  else if (type === "attendance") {
            data = getAttendanceSampleData("attendance");
            fileName = "Attendance_Marking.csv";
            guideLines = guides["attendance"];
        } else if (type === "monthlyDays") {
            data = data = [
                ["Prev.Emp ID", "Working Days", "OT Hours For Complete Pay Period"],
                ["EMP00123", "26", "0"],
            ];
            fileName = "Monthly_Days.csv";
            guideLines = guides["monthlyDays"];
        }

        const ws = XLSX.utils.aoa_to_sheet(data);
        let csv = XLSX.utils.sheet_to_csv(ws);
        const allGuides = [ `${type === "in" ? "Check In - Check Out" : type === "attendance" ? "Attendance Marking" : type === "monthlyDays" ? "Monthly Days" : "Daily Hours"} Guide (Input Format)`,
            ...commonGuides, ...guideLines, "Do Not remove these lines starting with '#' (they are for guidance only)"];
        if (allGuides?.length > 0) {
            const guideText = allGuides?.map(line => `########## ${line} ##########`)?.join("\n") + "\n####\n####\n";
            csv = guideText + csv;
        }
        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        handleCloseMenu();
    };
    const getDateRangeHeaders = (startDate, endDate) => {
        const headers = [];
        const start = new Date(startDate);
        const end = new Date(endDate);

        while (start <= end) {
            const dd = String(start.getDate()).padStart(2, "0");
            const mm = String(start.getMonth() + 1).padStart(2, "0");
            const yyyy = start.getFullYear();
            headers.push(`${dd}-${mm}-${yyyy}`);
            start.setDate(start.getDate() + 1);
        }
        return headers;
        }
    const handlePrefillDownload = () => {
        // input.month-year 2025-01-23
        setLoader(true);
        const [f_year, month] = input.month_year.split("-");
        const f_month = parseInt(month, 10).toString();
        GetBiometricPrefillHelper({
            month: f_month,
            year: f_year
        }).then((res) => {
            const responseData = res?.data?.data || [];
            const startDate = responseData[0]?.pay_period_start;
            const endDate = responseData[0]?.pay_period_end;

            let formattedData = [];            
            const totalDays =  startDate && endDate
                    ? Math.ceil((new Date(endDate) - new Date(startDate)) / (1000 * 60 * 60 * 24)
                        ) + 1 : 31
            if (type === "in") {
                formattedData = [
                    ["Prev.Emp ID", "Name", "DOJ", "In Date", "Out Date", "In Time", "Out Time"]
                ];
                const dateList = getDateRangeHeaders(startDate, endDate);

                dateList.forEach((date) => {
                    responseData?.forEach((item) => {
                        formattedData.push([
                            item.prev_emp_id || "",
                            item.emp_name || "",
                            item?.doj ? revertDateFormat(item?.doj) : "",
                            date,
                            date,
                            "",
                            ""
                        ]);
                    });
                });
            } else if (type === "daily") {
                const header = ["Prev.Emp ID", "Name", "DOJ"];
                if (startDate && endDate) {
                    const dateHeaders = getDateRangeHeaders(startDate, endDate);
                    header.push(...dateHeaders);
                }
                formattedData.push(header);
                responseData?.forEach(emp => {
                    const row = [
                        emp.prev_emp_id,
                        emp.emp_name,
                        emp?.doj ? revertDateFormat(emp?.doj) : "",
                        ...Array(totalDays).fill(emp.working_hrs || ""),
                    ];
                    formattedData.push(row);
                });
            } else if (type === "attendance") {
                // Attendance Marking prefill
                const header = ["Prev.Emp ID", "Name", "DOJ"];
                if (startDate && endDate) {
                    const dateHeaders = getDateRangeHeaders(startDate, endDate);
                    header.push(...dateHeaders);
                }
                header.push("OT Hours For Complete Pay Period");
                formattedData.push(header);

                responseData?.forEach(emp => {
                    const row = [
                        emp.prev_emp_id,
                        emp.emp_name,
                        emp?.doj ? revertDateFormat(emp?.doj) : "",
                         ...Array(totalDays).fill(emp.attendance || "1.0"),
                        emp.overtime_hours || ""
                    ];
                    formattedData.push(row);
                });
            } else if (type === "monthlyDays") {
                formattedData = [
                    ["Prev.Emp ID", "Name", "DOJ", "Working Days", "OT Hours For Complete Pay Period"],
                ];
                responseData?.forEach(emp => {
                    const row = [
                        emp.prev_emp_id,
                        emp.emp_name,
                        emp?.doj ? revertDateFormat(emp?.doj) : "",
                        "26",
                        emp.overtime_hours || ""
                    ];
                    formattedData.push(row);
                });
            }
            const typeGuides = guides[type] || [];
            const allGuides = [`${type === "in" ? "Check In - Check Out" : type === "attendance" ? "Attendance Marking" : type === "monthlyDays" ? "Monthly Days" : "Daily Hours"} Guide (Input Format)`,
                ...commonGuides,
                ...typeGuides,
                "Do Not remove these lines starting with '#' (they are for guidance only)"
            ];

            const ws = XLSX.utils.aoa_to_sheet(formattedData);
            let csv = XLSX.utils.sheet_to_csv(ws);

            if (allGuides?.length > 0) {
                const guideText = allGuides?.map(line => `########## ${line} ##########`)?.join("\n") + "\n####\n####\n";
                csv = guideText + csv;
            }
        
            const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            const fileTypeName = type === "in" ? "Check_In_Check_Out" : type === "attendance" ? "Attendance_Marking" : type === "monthlyDays" ? "Monthly_Days" : "Daily_Hours";
            link.download = `${fileTypeName}_${month}-${f_year}.csv`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setLoader(false);
            handleCloseMenu();
            setPrefillOpen(false);
            setInput({ month_year: `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}` })
        });
    };
    const handleClose = () => {
        setImport(false);
        setPrefillOpen(false);
        setInput({ month_year: `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}` })
        setFile(null);
        setRowHeaders([]);
        setHours(false);
        setAttendanceBulk(false);
        setInputData({ type: "Check In - Check Out" });
        setMode("Check In - Check Out");
        setExcelDbColMapping(initialColMapping);
        setFailedMessage("");
    };
    return (
        <>
            <Base>
                <Popup
                    maxWidth="xs"
                    openPopup={show}
                    setOpenPopup={setShow}
                    close={false}
                    hideDividers={true}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            textAlign: "center",
                            alignItems: "center",
                        }}
                    >
                        <Box sx={{ mt: 1, mb: 1, textAlign: "center !important" }}>
                            <img src={Warning} alt="UnSupport File" width={"25%"} />
                        </Box>
                        <FormControl>
                            <FormLabel id="gender-label">
                                <Typography variant="h5" className="blink">
                                    Invalid File Type, Accepted file type is .csv
                                </Typography>
                            </FormLabel>
                        </FormControl>
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                paddingTop: "10px",
                            }}
                        >
                            <Button
                                onClick={() => {
                                    setShow(false);
                                }}
                                variant="contained"
                                type="submit"
                                className="mpl-primary-btn profile-btn"
                                size="small"
                                sx={{
                                    margin: "10px",
                                }}
                            >
                                Close
                            </Button>
                        </Box>
                    </Box>
                </Popup>
                <Box sx={{ height: "87vh", overflowY: "auto", position: "relative", }}>
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: 2,
                            padding: "14px",
                            borderRadius: "12px",
                            boxShadow: 2,
                            width: "100%",
                            maxWidth: "800px",
                            margin: "0 auto"
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                flexWrap: "wrap",
                                gap: 1,
                                width: "100%",
                            }}
                        >
                            <Box
                                sx={{
                                    padding: "5px",
                                    borderRadius: "8px",
                                    backgroundColor: "#ffffff",
                                    border: "1px solid #dce3ea",
                                    cursor: "pointer",
                                    transition: "all 0.2s ease-in-out",
                                    "&:hover": {
                                        backgroundColor: "#e3f2fd",
                                    },
                                }}
                                onClick={(e) => handleOpenMenu(e, "sample")}
                            >
                                <Typography variant="body1" sx={{ fontWeight: 500, color: "#1976d2" }}>
                                    📄 Download Sample CSV Template
                                </Typography>
                            </Box>

                            <Box
                                sx={{
                                    padding: "5px",
                                    borderRadius: "8px",
                                    backgroundColor: "#ffffff",
                                    border: "1px solid #dce3ea",
                                    cursor: "pointer",
                                    transition: "all 0.2s ease-in-out",
                                    "&:hover": {
                                        backgroundColor: "#e8f5e9",
                                    },
                                }}
                                onClick={(e) => handleOpenMenu(e, "prefill")}
                            >
                                <Typography variant="body1" sx={{ fontWeight: 500, color: "#1976d2" }}>
                                    🔄 Download Prefill CSV Template
                                </Typography>
                            </Box>
                        </Box>

                        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseMenu}>
                            <MenuItem onClick={() => handleMenuItemClick("in")}>Check In - Check Out</MenuItem>
                            <MenuItem onClick={() => handleMenuItemClick("daily")}>Daily Hours</MenuItem>
                            <MenuItem onClick={() => handleMenuItemClick("attendance")}>Attendance Marking</MenuItem>
                            <MenuItem onClick={() => handleMenuItemClick("monthlyDays")}>Monthly Days</MenuItem>
                        </Menu>

                        <Box sx={{ display: "flex", gap: 2 }}>
                            <Button
                                variant="contained"
                                className="mpl-primary-btn"
                                component="span"
                                sx={{
                                    textTransform: "none",
                                    fontSize: "14px",
                                    padding: "8px 20px",
                                    height: "41px",
                                }}
                                disabled={getLoading || loader2}
                                onClick={handleImport}
                                startIcon={loader2 ? <CircularProgress size={18} color="inherit" /> : null}
                            >
                               Import CSV
                            </Button>
                            <Button
                                variant="contained"
                                className="mpl-primary-btn"
                                disabled={empdata?.length === 0 || empdata === undefined || loader3}
                                onClick={handleSubmit}
                                startIcon={loader3 ? <CircularProgress size={18} color="inherit" /> : null}
                                sx={{
                                    textTransform: "none",
                                    fontSize: "14px",
                                    padding: "8px 20px",
                                    height: "40px",
                                    boxShadow: empdata?.length > 0 ? 3 : 0,
                                }}
                            >
                                Submit
                            </Button>
                        </Box>
                    </Box>
                    <BackdropMeepl open={(getLoading || atdCodeLoading)} dark={false}/> 
                    {failedMessage && (
                        <Box sx={{ width: "350px", margin: "auto", border: "1px solid #ddd", 
                                    borderRadius: 2, backgroundColor: "#f9f9f9", display: "flex", 
                                    alignItem: "center", gap: 2, px: 6, py: 4, mt: "5%"}}>
                            <WarningAmberIcon sx={{ color: "#ff4f49", fontSize: 30 }} />
                            <Typography variant="subtitle1" sx={{ color: "#ff4f49", fontSize: "0.95rem" }}>
                                {failedMessage}
                            </Typography>
                        </Box>
                    )}
                    {(empdata?.length > 0) && (
                        <MaterialTable
                            columns={
                                attendanceBulk && hours
                                    ? [
                                        {
                                            title: "Prev.Emp ID",
                                            field: "previous_employee_id",
                                            cellStyle: { padding: "10px 10px 10px 13px" },
                                            grouping: false,
                                        },
                                        {
                                            title: "OT Hours For Complete Pay Period",
                                            field: "overtime_hours",
                                            cellStyle: { padding: "10px 10px 10px 25px" },
                                            render: rowData => rowData.overtime_hours ? rowData.overtime_hours : "NA"

                                        },
                                    ]
                                    : monthlyDaysBulk
                                    ? [
                                        {
                                            title: "Prev.Emp ID",
                                            field: "previous_employee_id",
                                            cellStyle: { padding: "10px 10px 10px 13px" },
                                            grouping: false,
                                        },
                                        {
                                            title: "Working Days",
                                            field: "working_days",
                                            cellStyle: { padding: "10px 10px 10px 25px" },
                                            render: rowData => rowData.working_days ? rowData.working_days : "NA"

                                        },
                                        {
                                            title: "OT Hours For Complete Pay Period",
                                            field: "overtime_hours",
                                            cellStyle: { padding: "10px 10px 10px 25px" },
                                            render: rowData => rowData.overtime_hours ? rowData.overtime_hours : "NA"

                                        },
                                    ]
                                    : hours
                                    ? [
                                        {
                                            title: "Prev.Emp ID",
                                            field: "previous_employee_id",
                                            cellStyle: { padding: "10px 10px 10px 13px" },
                                            grouping: false,
                                        },
                                        {
                                            title: "Total Work Hours",
                                            field: "total_hours",
                                            cellStyle: { padding: "10px 10px 10px 25px" },
                                        },
                                    ]
                                    : [
                                        {
                                            title: "Prev.Emp ID",
                                            field: "previous_employee_id",
                                            cellStyle: { padding: "10px 10px 10px 13px" },
                                            grouping: false,
                                        },
                                        {
                                            title: "In Date",
                                            field: "in_date",
                                            cellStyle: { padding: "10px 10px 10px 13px" },
                                            render: rowData => revertDateFormat(rowData?.in_date)
                                        },
                                        {
                                            title: "Out Date",
                                            field: "out_date",
                                            cellStyle: { padding: "10px 10px 10px 13px" },
                                             render: rowData => revertDateFormat(rowData?.out_date)
                                        },
                                        {
                                            title: "In Time",
                                            field: "in_time",
                                            cellStyle: { padding: "10px 10px 10px 13px" },
                                        },
                                        {
                                            title: "Out Time",
                                            field: "out_time",
                                            cellStyle: { padding: "10px 10px 10px 13px" },
                                        },
                                    ]
                            }
                            data={empdata}
                            options={{
                                maxBodyHeight: "65vh",
                                minBodyHeight: "65vh",
                                rowStyle: { fontSize: "13px" },
                                headerStyle: { padding: "10px 10px 10px 13px", fontWeight: "bold" },
                                sorting: true,
                                search: true,
                                searchText: "",
                                searchFieldAlignment: "right",
                                searchAutoFocus: true,
                                searchFieldVariant: "standard",
                                filtering: false,
                                paging: true,
                                pageSizeOptions: [25, 50],
                                pageSize: 25,
                                paginationType: "stepped",
                                showFirstLastPageButtons: false,
                                paginationPosition: "bottom",
                                exportButton: false,
                                exportAllData: false,
                                exportFileName: "Bio Metric",
                                addRowPosition: "first",
                                selection: false,
                                actionsColumnIndex: -1,
                                showSelectAllCheckbox: true,
                                showTextRowsSelected: true,
                                grouping: false,
                                columnsButton: false,
                            }}
                            actions={[
                                {
                                    icon: () => <IconButton sx={{ padding: "0px" }}><EditIcon /></IconButton>,
                                    tooltip: "Edit",
                                    onClick: (_event, rowData) => { handleEdit(rowData) },
                                },
                                {
                                    icon: () => <IconButton sx={{ padding: "0px" }}><DeleteIcon /></IconButton>,
                                    tooltip: "Delete",
                                    onClick: (_event, rowData) => { handleConfirmDelete(rowData) },
                                },
                            ]}
                            title="Time Bulk Upload"
                        />
                    )}
                    <Popup
                        maxWidth="xs"
                        fullWidth={true}
                        title="Attention Needed!"
                        openPopup={showConfirmPopup}
                        close={false}
                        setOpenPopup={setShowConfirmPopup}
                    >
                        <Typography variant="h5"> You will lose the imported data. Do you want to submit it before proceeding? </Typography>
                        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
                            <Button
                                onClick={handleCancel}
                                className="mpl-primary-btn"
                                disabled={loader2}
                                startIcon={loader2 ? <CircularProgress size={18} color="inherit" /> : null}

                            >
                                No
                            </Button>

                            <Button
                                onClick={() => {
                                    setShowConfirmPopup(false); // Close popup and retain existing data
                                }}
                                className="mpl-primary-btn"
                            >
                                Yes
                            </Button>

                        </Box>
                    </Popup>
                    <Popup
                        fullWidth
                        title={ attendanceBulk ? "Edit Employee Attendance" : monthlyDaysBulk ? "Edit Employee Monthly Days" : "Edit Employee Time"}
                        openPopup={openPopup}
                        setOpenPopup={setOpenPopup}
                    >
                        <form
                            onSubmit={(e) => {
                                e.preventDefault();
                                handleEditSubmit(editedRecord);
                            }}
                        >
                            <TextField
                                variant="standard"
                                size="small"
                                label="Previous Employee ID"
                                value={editedRecord?.previous_employee_id || ""}
                                onChange={(e) =>
                                    setEditedRecord({ ...editedRecord, previous_employee_id: e.target.value })
                                }
                                fullWidth
                                sx={{ mb: 3 }}
                                required
                            />
                            {monthlyDaysBulk && (
                                <>
                                <TextField
                                    variant="standard"
                                    size="small"
                                    label="Working Days"
                                    value={editedRecord?.working_days || ""}
                                    onChange={(e) =>
                                        setEditedRecord({ ...editedRecord, working_days: e.target.value })
                                    }
                                    fullWidth
                                    type="number"
                                    sx={{ mb: 3 }}
                                />
                                <TextField
                                    variant="standard"
                                    size="small"
                                    label="Overtime Hours"
                                    value={editedRecord?.overtime_hours || ""}
                                    onChange={(e) =>
                                        setEditedRecord({ ...editedRecord, overtime_hours: e.target.value })
                                    }
                                    type="number"
                                    fullWidth
                                    sx={{ mb: 3 }}
                                />
                                </>
                            )}
                            {(!hours && !monthlyDaysBulk)&& (
                                <>
                                    <FormControl fullWidth sx={{ mb: 3 }}>
                                        <CommonDatePicker
                                            variant="standard"
                                            size="small"
                                            name="in_date"
                                            label="In Date"
                                            pickerType="date"
                                            onKeyPress={(e) => e.preventDefault()}
                                            onKeyDown={(e) => e.preventDefault()}
                                            pickerFormat="dd/MM/yyyy"
                                            DefaultDTvalue={editedRecord?.in_date}
                                            handleChange={(value) =>
                                                setEditedRecord({
                                                    ...editedRecord,
                                                    in_date: value
                                                        ? `${value.getFullYear()}-${("0" + (value.getMonth() + 1)).slice(-2)}-${("0" + value.getDate()).slice(-2)}`
                                                        : "",
                                                })
                                            }
                                            required
                                        />
                                    </FormControl>
                                    <FormControl fullWidth sx={{ mb: 3 }}>
                                        <CommonDatePicker
                                            variant="standard"
                                            size="small"
                                            name="out_date"
                                            label="Out Date"
                                            pickerType="date"
                                            onKeyPress={(e) => e.preventDefault()}
                                            onKeyDown={(e) => e.preventDefault()}
                                            pickerFormat="dd/MM/yyyy"
                                            DefaultDTvalue={editedRecord?.out_date}
                                            handleChange={(value) =>
                                                setEditedRecord({
                                                    ...editedRecord,
                                                    out_date: value
                                                        ? `${value.getFullYear()}-${("0" + (value.getMonth() + 1)).slice(-2)}-${("0" + value.getDate()).slice(-2)}`
                                                        : "",
                                                })
                                            }
                                            required
                                        />
                                    </FormControl>
                                    <TextField
                                        variant="standard"
                                        size="small"
                                        label="In Time"
                                        value={editedRecord?.in_time || ""}
                                        onChange={(e) =>
                                            setEditedRecord({ ...editedRecord, in_time: e.target.value })
                                        }
                                        fullWidth
                                        sx={{ mb: 3 }}
                                        required
                                    />
                                    <TextField
                                        variant="standard"
                                        size="small"
                                        label="Out Time"
                                        value={editedRecord?.out_time || ""}
                                        onChange={(e) =>
                                            setEditedRecord({ ...editedRecord, out_time: e.target.value })
                                        }
                                        fullWidth
                                        sx={{ mb: 3 }}
                                        required
                                    />
                                </>
                            )}
                            <Grid container spacing={1.5}>
                                {hours &&
                                    editedRecord?.time_json && 
                                    Object.keys(editedRecord?.time_json)?.map((day, index) => (
                                        <Grid item xs={4} key={day}>
                                            <Grid container spacing={1} alignItems="center">
                                                <Grid item xs={6} sx={{ textAlign: "left" }}>
                                                    <Typography variant="body2" fontWeight="bold">
                                                        {revertDateFormat(day)}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        variant="standard"
                                                        size="small"
                                                        value={editedRecord.time_json[day] || ""}
                                                        onChange={(e) =>
                                                            setEditedRecord({
                                                                ...editedRecord,
                                                                time_json: {
                                                                    ...editedRecord.time_json,
                                                                    [day]: e.target.value,
                                                                },
                                                            })
                                                        }
                                                        sx={{
                                                            width: "60px",
                                                            "& .MuiInputBase-root": {
                                                                height: 30,
                                                                textAlign: "center",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                            },
                                                            "& .MuiOutlinedInput-input": {
                                                                padding: "5px",
                                                                textAlign: "center",
                                                            },
                                                        }}
                                                        inputProps={{ style: { textAlign: "center" } }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    ))}
                            </Grid>
                            <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
                                <Button onClick={() => setOpenPopup(false)} className="mpl-primary-btn">
                                    Cancel
                                </Button>
                                <Button type="submit" variant="contained" className="mpl-primary-btn"
                                    disabled={updatingLoader}
                                    startIcon={updatingLoader ? <CircularProgress size={18} color="inherit" /> : null}
                                >
                                    Save
                                </Button>
                            </Box>
                        </form>
                    </Popup>
                    <Popup
                        maxWidth="sm"
                        fullWidth={true}
                        title="Time Bulk Import"
                        openPopup={Import}
                        close={false}
                        setOpenPopup={setImport}
                    >
                        <Box sx={{ my: 1, mx: 2 }}>
                            <FormControl sx={{ marginBottom: "20px" }} fullWidth size="small">
                                <InputLabel sx={{ marginLeft: "-15px" }} id="status">Select type of time bulk upload</InputLabel>
                                <Select
                                    name="type"
                                    labelId="type"
                                    id="type"
                                    value={inputData?.type}
                                    label="Select type of time bulk upload"
                                    variant="standard"
                                    onChange={handleInputChange}
                                >
                                    <MenuItem value={'Check In - Check Out'}>Check In - Check Out</MenuItem>
                                    <MenuItem value={'Daily Hours'}>Daily Hours</MenuItem>
                                    <MenuItem value={'Attendance Marking'}>Attendance Marking</MenuItem>
                                    <MenuItem value={'Monthly Days'}>Monthly Days</MenuItem>
                                </Select>
                            </FormControl>
                            {(hours || monthlyDaysBulk) && (

                                <FormControl fullWidth size="small">
                                    <CommonDatePicker
                                        name="month_year"
                                        openTo="month"
                                        required
                                        views={['year', 'month']}
                                        label="Month and Year"
                                        pickerType="date"
                                        variant="standard"
                                        onKeyDown={(e) => e.preventDefault()}
                                        onKeyPress={(e) => e.preventDefault()}
                                        pickerFormat="MM/yyyy"
                                        DefaultDTvalue={input.month_year}
                                        minDate={new Date().setFullYear(new Date().getFullYear() - 3)}
                                        maxDate={new Date()}
                                        handleChange={(value) =>
                                            handleInput({
                                                target: {
                                                    name: "month_year",
                                                    value: value
                                                        ? `${value?.getFullYear()}-${("0" + (value?.getMonth() + 1)).slice(-2)}-${("0" + value?.getDate()).slice(-2)}`
                                                        : "",
                                                },
                                            })
                                        }
                                    />
                                </FormControl>

                            )}
                            <>
                                <div style={{ display: "flex", alignItems: "center", gap: "16px", justifyContent: "center", margin: "20px 0px 20px 0px" }}>
                                    <label
                                        htmlFor="contained-button-file"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            border: "2px dashed #883bd5",  // Dashed border like a drop area
                                            padding: "50px",
                                            borderRadius: "8px",
                                            cursor: "pointer",
                                            backgroundColor: "#fff", // Light blue background
                                            width: "300px",
                                            textAlign: "center",
                                            fontSize: "14px",
                                            color: "#883bd5",
                                            height: "80px",
                                        }}
                                    >
                                        {file ? file?.name?.substring(0, 20) + "..." : "Select File"}
                                        <input
                                            accept=".csv"
                                            id="contained-button-file"
                                            type="file"
                                            style={{ display: "none" }}
                                            multiple={false}
                                            onChange={fileSelected}
                                        />
                                    </label>
                                </div>
                            </>
                            {(!hours && file) && (
                                <>
                                    <Box
                                        style={{
                                            display: "grid",
                                            gridTemplateColumns: "1fr 1fr",
                                            alignItems: "center",
                                            padding: 5,
                                            borderBottom: "1px solid gray",
                                        }}
                                    >
                                        <Typography variant="h6" style={{ textAlign: "center" }}>
                                            Imported Headers
                                        </Typography>
                                        <Typography variant="h6" style={{ textAlign: "center" }}>
                                            Meepl Fields
                                        </Typography>
                                    </Box>
                                    {excelDbColMapping.map((col) => (
                                        <Grid
                                            key={col.db}
                                            container
                                            spacing={2}
                                            style={{
                                                padding: 5,
                                                alignItems: "center",
                                            }}
                                        >
                                            <Grid sx={{ mt: 2 }} item xs={6} container alignItems="center" spacing={1}>
                                                <Grid item xs>
                                                    <Select
                                                        onChange={(e) => setColMapping(e.target.value, col.db)}
                                                        value={col.excel}
                                                        fullWidth
                                                        required={col.required}
                                                        variant="standard"
                                                    >
                                                        {rowHeaders.map((header) => (
                                                            <MenuItem key={header} value={header}>
                                                                {header}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </Grid>
                                                {col.excel && (
                                                    <Grid item>
                                                        <IconButton onClick={() => clearColMapping(col.db)}>
                                                            <CloseIcon />
                                                        </IconButton>
                                                    </Grid>
                                                )}
                                            </Grid>
                                            <Grid sx={{ mt: 2 }} item xs={6}>
                                                <Typography>
                                                    {col.label || col.db}
                                                    {col.required && " *"}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    ))}
                                </>
                            )}
                              <Box mt={(!hours && file) ? 2 : 0}>
                                <AttendanceLegend type={inputData?.type} rows={rows} />
                              </Box>
                            <Box sx={{ display: "flex", justifyContent: "space-between", my: 2 }}>
                                <Button
                                    onClick={() => handleClose()}
                                    className="mpl-primary-btn"
                                    disabled={uploadProgress > 0 && uploadProgress < 100}
                                >
                                    Close
                                </Button>

                                <div>
                                    <Tooltip title={file ? "" : "Please select a file"}>
                                        <span>
                                            <Button
                                                disabled={!file || (uploadProgress > 0 && uploadProgress < 100)}
                                                variant="contained"
                                                type="submit"
                                                className="mpl-primary-btn"
                                                onClick={addEmployeeStage}
                                                startIcon={(uploadProgress > 0 && uploadProgress < 100) ? <CircularProgress size={18} color="inherit" /> : null}
                                            >
                                                Upload
                                            </Button>
                                        </span>
                                    </Tooltip>
                                </div>

                            </Box>

                        </Box>
                    </Popup>
                    <Popup
                        maxWidth="xs"
                        fullWidth={true}
                        title="Prefill Template"
                        openPopup={prefillOpen}
                        close={false}
                        setOpenPopup={setPrefillOpen}
                    >
                        <Box sx={{ m: 1 }}>
                            <FormControl fullWidth size="small">
                                <CommonDatePicker
                                    name="month_year"
                                    openTo="month"
                                    required
                                    views={['year', 'month']}
                                    label="Month and Year"
                                    pickerType="date"
                                    variant="standard"
                                    onKeyDown={(e) => e.preventDefault()}
                                    onKeyPress={(e) => e.preventDefault()}
                                    pickerFormat="MM/yyyy"
                                    DefaultDTvalue={input.month_year}
                                    minDate={new Date(new Date(minDojYear).getFullYear(), 0, 31)}
                                    maxDate={new Date()}
                                    handleChange={(value) =>
                                        handleInput({
                                            target: {
                                                name: "month_year",
                                                value: value
                                                    ? `${value?.getFullYear()}-${("0" + (value?.getMonth() + 1)).slice(-2)}-${("0" + value?.getDate()).slice(-2)}`
                                                    : "",
                                            },
                                        })
                                    }
                                />
                            </FormControl>
                            <Box sx={{ display: "flex", justifyContent: "space-between", my: 2 }}>
                                <Button
                                    onClick={() => handleClose()}
                                    className="mpl-primary-btn"
                                >
                                    Close
                                </Button>
                                <Button
                                    variant="contained"
                                    type="submit"
                                    className="mpl-primary-btn"
                                    onClick={handlePrefillDownload}
                                    disabled={loader}
                                    startIcon={loader ? <CircularProgress size={18} color="inherit" /> : null}
                                >
                                    Download
                                </Button>
                            </Box>
                        </Box>
                    </Popup>
                    <ConfirmationDialog
                        title="Do you wish to proceed?"
                        openDialog={openDialog}
                        closeDialog={setOpenDialog}
                        OkButtonText="Delete"
                        onSubmit={handleDelete}
                    />
                </Box>


            </Base >
        </>
    );
};

const validateWorkingDays = (value) => {
  if (value === undefined || value === null) return null;

  const cleaned = String(value).trim();
  if (cleaned === "") return null;

  const isNumber = /^[0-9]+$/.test(cleaned);
  if (!isNumber) return null;

  const num = Number(cleaned);
  if (num < 0 || num > 31) return null;

  return cleaned; // valid
};


const AttendanceLegend = ({ type, rows }) => {
    const legends = {
        "Attendance Marking": [
            ...(rows || [])?.map((item) => {
                const code = (item?.user_code || []).join(" / ");
                return `${code} : ${item?.meepl_label}`
            }), 
        "- → No data (like DOJ mid-month/LOP)",
        "Dates → dd-mm-yyyy format (e.g. 01-01-2025)",
        "Prev.Emp ID → Reference ID / Employee ID from the legacy system / Org ID / Biometric ID as applicable."
        ],
        "Check In - Check Out": [
        "🕗 In Time/Out Time → hh:mm:ss format (e.g. 08:00:00)",
        "📅 In Date/Out Date → dd-mm-yyyy format (e.g. 01-01-2025)",
        "Prev.Emp ID → Reference ID / Employee ID from the legacy system / Org ID / Biometric ID as applicable."
        ],
        "Daily Hours": [
        "⏱️ Work Hour Code is WH9 → Enter 9",
        "📅 Dates → dd-mm-yyyy format (e.g. 01-01-2025)",
        "Prev.Emp ID → Reference ID / Employee ID from the legacy system / Org ID / Biometric ID as applicable."
        ],
        "Monthly Days" : [
        "Working Days cannot exceed the total days in the selected month.",
        "Prev.Emp ID → Reference ID / Employee ID from the legacy system / Org ID / Biometric ID as applicable."
        ]
    };
  let content = null;
  if (type === "Attendance Marking") {
    content = (
    <List
        dense
        sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 1, // spacing between items
        }}
    > {legends["Attendance Marking"]?.map((item, index) => (
        <ListItem key={`legends1-${index}`} sx={{ width: "auto", py: 0, px: 1, backgroundColor: "#f0f0f0", borderRadius: 1, }}>
        <ListItemText
            primary={item}
            primaryTypographyProps={{ fontSize: "10px" }}
            />
        </ListItem>
    ))}
    </List>

    );
  } else if (type === "Check In - Check Out") {
    content = (
        <List dense
            sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 1, // spacing between items
            }}
        >
        {legends["Check In - Check Out"]?.map((item, index) => (
            <ListItem key={`legends2-${index}`} sx={{ width: "auto", py: 0, px: 1, backgroundColor: "#f0f0f0", borderRadius: 1, }}>
            <ListItemText
                primary={item}
                primaryTypographyProps={{ fontSize: "10px" }}
                />
            </ListItem>
        ))}
        </List>
    );
  } else if (type === "Daily Hours") {
    content = (
        <List dense
            sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 1,
            }}
        >
            {legends["Daily Hours"]?.map((item, index) => (
                <ListItem key={`legends3-${index}`} sx={{ width: "auto", py: 0, px: 1, backgroundColor: "#f0f0f0", borderRadius: 1, }}>
                <ListItemText
                    primary={item}
                    primaryTypographyProps={{ fontSize: "10px" }}
                />
                </ListItem>
            ))}
        </List>
    );
  } else if (type === "Monthly Days") {
    content = (
    <List
        dense
        sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 1, // spacing between items
        }}
    > {legends["Monthly Days"]?.map((item, index) => (
        <ListItem key={`legends1-${index}`} sx={{ width: "auto", py: 0, px: 1, backgroundColor: "#f0f0f0", borderRadius: 1, }}>
        <ListItemText
            primary={item}
            primaryTypographyProps={{ fontSize: "10px" }}
            />
        </ListItem>
    ))}
    </List>

    );
  }
    if (!content) return null;

    return (
    <Accordion sx={{ backgroundColor: "#f9f9f9", borderRadius: 2, border: "1px solid #ddd",
            '&:not(.Mui-expanded)': {
                border: "none",
                borderBottom: "1px solid #ddd",
            }
     }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}
            sx={{ 
                minHeight: "32px !important", 
                '& .MuiAccordionSummary-content': {
                    margin: "4px 0 !important"
                }
            }}
        >
        <Box display="flex" alignItems="center" gap={1}>
            <Typography variant="subtitle1">{type} Guide</Typography>
            <Typography variant="subtitle2" color="text.secondary">
              Input Format
            </Typography>
        </Box>
        </AccordionSummary>
        <AccordionDetails 
            sx={{ 
                paddingTop: "4px",
                paddingBottom: "0px"
            }}
        >
            {content}
        </AccordionDetails>
    </Accordion>
  );
};


export default BioMetricUpload;